<template>
  <main class="page-projects page-show-project p-0">
    <div class="nav-container">
      <div class="container">
        <ul class="nav nav-pills nav-fill">
          <li class="nav-item">
            <router-link class="nav-link active" :to="{ name: 'modules.show' }" aria-current="page">Dati</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'modules.edit' }">Modifica</router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="container pt-5">
      <div class="table-responsive mb-5">
        <table class="table table-condensed visea-info-table">
          <tbody>
          <tr>
            <td class="title">Progetto</td>
            <td>{{ project.name }}</td>
          </tr>
          <tr>
            <td class="title">Nome livello</td>
            <td>{{ module.name }}</td>
          </tr>
          <tr>
            <td class="title">Note</td>
            <td>{{ module.notes }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
        <h2 class="mb-0">Segnaposti<template v-if="points.length > 0"> ({{ totalResults }})</template></h2>
        <router-link class="btn btn-primary font-weight-bold text-white" :to="{ name: 'points.new' }">Aggiungi segnaposto</router-link>
      </div>

      <template v-if="points && points.length > 0">
        <AwlTable striped :heading="tableHeadings" :rows="tableRows" class="mb-3">
          <template #column-nb-0="{ rowIndex }">{{ rowIndex + 1 }}</template>

          <template #column-key-templateId="{ value }">{{ value | templateId }}</template>
          <template #column-key-colour="{ value }">
            <div class="colour-row">
              <ColouredSquare :colour="value | colour" /> <span>{{ value | colourName }}</span>
            </div>
          </template>

          <template #actions-content="{ row }">
            <ActionShow :to="{ name: 'points.show', params: { pointId: row.id } }" />
            <ActionEdit class="ml-2" :to="{ name: 'points.edit', params: { pointId: row.id } }" />
          </template>
        </AwlTable>
      </template>
      <Alert v-else status="primary">Nessun segnaposto presente.</Alert>
    </div>
  </main>
</template>
<script>

import rolesMixin from '@/mixins/roles';
import pageableMixin from '@/libs/Pagination/mixins/pageable';
import $api from '@/libs/OAuth2/services/api';
import templateIdFilter from '@/filters/templateIdFilter';
import colourFilter, { colourNameFilter } from '@/filters/colourFilter';

export default {
  name: 'project-show',
  mixins: [rolesMixin, pageableMixin],
  components: {
    Alert: () => import('@/libs/Feedback/components/Alert'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionShow: () => import('@/libs/Table/components/Actions/ActionShow'),
    ActionEdit: () => import('@/libs/Table/components/Actions/ActionEdit'),
    ColouredSquare: () => import('@/views/components/Form/Widgets/ColouredSquare'),
  },
  filters: {
    templateId: templateIdFilter,
    colour: colourFilter,
    colourName: colourNameFilter,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    module: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      points: [],
    };
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'pos', label: '' },
        { key: 'windowTitle', label: 'Titolo' },
        { key: 'title', label: 'Sottotitolo' },
        { key: 'year', label: 'Anno' },
        { key: 'templateId', label: 'Template' },
        { key: 'colour', label: 'Colore' },
      ];
    },
    tableRows () {
      return (this.points || []);
    },
  },
  methods: {
    fetchResults (page = this.page) {
      return $api.listPoints(this.module.id, 1, 50)
        .then(res => {
          this.points = res?.data?.points || [];
          this.setMetadata(res?.data);
        })
        .catch(() => this.$log.error)
      ;
    },
  },
  mounted () {
    this.fetchResults();
  },
};

</script>

<style lang="scss">

.colour-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    margin-left: 10px;
  }
}
</style>
